import { ensureHttpsPrefix } from '@shared/utils/urlHelpers';

export function getValidBookingLink(bookingLink: string | undefined): URL | undefined {
  if (!bookingLink) {
    return undefined;
  }
  bookingLink = ensureHttpsPrefix(bookingLink);
  try {
    return new URL(bookingLink);
  } catch (error) {
    return undefined;
  }
}
